import React, { Component } from "react"
import { Link } from "react-router-dom"
import AppContext from "../../shared/AppContext"
import * as imageAsset from "../../shared/images"

import "./homePageProductCard.scss"

class HomePageProductCard extends Component {
  render() {
    let { slug, name } = this.props

    return (
      <AppContext.Consumer>
        {({ trackEvent }) => (
          <Link
            to={`/marketplace/${slug[0]}`}
            className="hp-product-card-container card-anim"
            onClick={() =>
              trackEvent("Clicked Product Card", {
                section: `HomePage ETR Insights Card: ${name}`,
                link: `/marketplace/${slug[0]}`,
              })
            }
          >
            <div className="hp-product-card-header">
              <div
                className="no-image"
                style={{
                  backgroundImage: `url(https://s3.amazonaws.com/dev-etr/images/fallback/Background.png)`,
                }}
              >
                <img
                  className="logo-sm"
                  src={imageAsset.etrColorInsights}
                  alt={name}
                />
              </div>
            </div>
            <div className="hp-product-card-body">
              <div className="hp-product-card-title">
                <div id="hp-product-card-title-name">{name}</div>
              </div>
            </div>
          </Link>
        )}
      </AppContext.Consumer>
    )
  }
}

export default HomePageProductCard
